//Add density multiplier to responsive images based on device pixel ratio
const images = document.querySelectorAll('img[data-srcset]');
const density = window.devicePixelRatio;

if(images && density > 1) {
  images.forEach(image => {
    image.setAttribute('data-multiplier', density);
  });
}
